<template>
    <div class="serving-size-container">
        <span class="serving-size-label">Serving Size</span>
        <span class="serving-size-value">{{ item.ServingDisplay }}</span>
    </div>
</template>

<script>
export default {
    name: 'serving-size',
    props: {
        item: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>
.serving-size-container {
    display: flex;
    flex-direction: row;
    gap: 12px;
    font-size: 12px;
}

.serving-size-label {
    font-weight: 700;
}
</style>